declare let window: Window & {
  ue: { count: (arg0: string, arg1: number, arg2: { scope: string; }) => void; }
  ueLogError: (arg0: any, arg1: { logLevel: string; message: string; }) => void
}


const options = {
  wb: 1
}

const SCOPES = {
  CRITICAL_FEATURE: 'cf',
  FINISHED_LOADING: 'ld',
  TIME_TO_CLICK: 'tc',
  TIME_ZERO: 't0'
}

function count(key: string, scopeValue = 0) {
  if (!window.ue) {
    return
  }
  const scope = { scope: `c${scopeValue}` }
  window.ue.count(key, 1, scope)
}

function logError(error: any, info: any) {
  if (window.ueLogError) {
    const additionalInfo = {
      logLevel: 'ERROR',
      message: info
    }
    window.ueLogError(error, additionalInfo)
  } else {
    count('DVWeb::Storefront::JSFatal::ueLogErrorIsMissing')
  }
}

function getMetricScript(metric: string) {
  return `if (window.ue && window.uet) { window.uet('${metric}') }`
}

export { count, logError, options, getMetricScript, SCOPES }
